export default __webpack_public_path__ + "static/media/clock.66bbaede.svg";